<template>
  <div class="about">
    <div class="banner">
      <h3>X联网</h3>
      <p>为产业互联网而来</p>
    </div>

    <div class="w1200 container">
      <h3 class="text-center">公司简介</h3>
      <p>
        北京农信互联数据科技有限公司（简称“农信数据”）是一家互联网技术高科技企业。自成立以来，一直致力于农业互联网生态圈建设和产业互联网技术软件开发。集成物联网、AI技术、云计算、大数据等高新技术和先进的管理理念，打造出以猪服务、猪交易和猪金融为主体的猪联网平台，以此提高了猪行业的整体经营效率。此后，农信数据不断演进，研发出以产业大数据为基础、供应链为支撑的产业互联网解决方案--X联网。X联网是基于开发和运营猪联网的成功经验，针对行业管理、服务、交易、物流、金融、智能6大核心问题，以适合产业运营规律和发展趋势的互联网解决方案。农信数据以技术输出为基础，咨询、资源、资金、资本相结合，结合团队对产业互联网的深刻认知，在短时间内就可以成功交付出一套完整的并且最适合本行业的产业互联网平台，有力推动产业数字化升级，形成以产业智能大数据为基础，产业供应链为支撑，产融结合的产业综合服务网络平台，使产业更加数据化、智能化，提升产业效率，增厚产业效益。截至目前，农信数据已经成功研发出蛋联网、渔联网、驴联网、狐联网、柑橘联网、大蒜联网和玉米联网等一系列不同产业的生态平台。
      </p>
      <p>
        “产业互联网”的新时代已经到来，农信数据将不断前行，专注于助力各产业龙头企业步入产业互联网新时代。帮助其摆脱产业周期，完成产业服务化、服务产品化的顺利转型，使他们从生产者，转变成行业服务者，从而避免产业周期，基业长青！
      </p>
      <p>
        公司获得多个软件著作权及发明专利，并荣获中关村高新技术企业称号！随着时代的进步，农信数据将以其专业、精湛的技术研发实力和前瞻、稳健的大局观为更多的产业龙头企业服务！
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },

  created() {},
  methods: {},
}
</script>
<style lang="scss">
@import '~@/assets/pc/css/about.scss';
</style>
